import React from "react";

const QASection = () => {
  const qaData = [
    {
      question: "以前購入したものはオレンジ色でサラサラだったのですが、今回のものはピンク色でふわふわの状態でした。品質や内容に変更がないとは聞いておりますが、このような違いが起きるのはなぜかをお伺いしたいです。",
      answer:
        "エッセンシャルビタミンCに使われている素材は、農薬を使わない、オーガニックやワイルドグレードの農作物でございます。インと同様で、全て自然素材で、採取される年によって気候も違うので、味が異なってまいります。従いまして工業製品として扱われる合成アスコルビン酸のように毎回同じ味、同じ色、ということはあり得ません。品質に問題はないのでご安心ください。",
      img: "https://img.freepik.com/free-vector/woman-thinking-isolated-illustration-design_24911-115070.jpg?t=st=1743465892~exp=1743469492~hmac=81a97f3e20a737ca7e74ee0e9ca28817c2f58071cbf8fb344aae01be2f15a341&w=900",
    },
    {
      question: "原料は海外から輸入して国内で製造しているのでしょうか？それとも、海外で採取製造して出来上がったものを輸入しているのでしょうか？",
      answer:
        "基本的には海外で採取、オーガニック認定工場で製造されたものを輸入しております。",
      img: "https://img.freepik.com/free-vector/thinking-face-concept-illustration_114360-30863.jpg?t=st=1743465998~exp=1743469598~hmac=cd824de3fe0929df70c3324a050d8096341f15721327c3efcf4d70e24a56c39c&w=900",
    },
    {
      question: "この製品はビーガン向けですか？",
      answer: "はい！私たちのビタミンCは100%植物由来で、動物由来の成分や合成添加物は一切含まれていません。",
      img: "https://img.freepik.com/free-vector/young-woman-with-worried-face_10045-760.jpg?t=st=1743465930~exp=1743469530~hmac=a15de9140b9c16975f1ba6b920a62443cf9f02cef4836928c87f7662457f8f15&w=900"
    }
    
  ];

  return (
    <section className="p-8 py-16">
     <h2 className="text-7xl text-center font-extrabold text-gray-900  underline decoration-yellow-500">
     よくある質問 (FAQ)
        </h2>
      <div className="space-y-8 mt-12">
        {qaData.map((item, index) => (
          <div
            key={index}
            className={`flex items-center ${index % 2 === 0 ? "flex-row" : "flex-row-reverse"}`}
          >
            <div className="w-1/3 flex justify-center">
              <img
                src={item.img}
                alt="Illustration"
                className="w-60 h-60 "
              />
            </div>
            <div className="w-2/3 bg-white p-6 rounded-2xl border-4 border-yellow-500 shadow-md relative">
              <div className="absolute top-0 left-5 w-8 h-8 bg-yellow-500 rotate-45 -translate-y-1/2 border-l-4 border-t-4 border-yellow-500"></div>
              <h3 className="text-2xl font-bold text-yellow-700">【Q】 {item.question}</h3>
              <p className="text-xl text-gray-800 mt-6">【A】 {item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default QASection;
